// extracted by mini-css-extract-plugin
module.exports = {"Date":"Label__Date_3WKh9","Video":"Label__Video_D6gID"};